/*
 * @Author: your name
 * @Date: 2020-06-08 19:40:42
 * @LastEditTime: 2020-09-17 20:28:13
 * @LastEditors: Please set LastEditors
 * @Description: 客服消息解析处理（非聊天页）
 * @FilePath: /LonBonStore/src/components/customerService/messageParsing.js
 */

var messageParsingJS = {
    data() {
        return {}
    },
    computed: {
        wsdata() {
            return this.$store.state.wsdata;
        }
    },
    watch: {
        wsdata(obj) {
            // 处理客服消息
            if (obj.msgType == 15 || obj.msgType == 18) {
                this.handlingCSM(obj);
            }
        }
    },
    methods: {
        // 处理客服消息(不在聊天也页中)
        handlingCSM(message_) {
            let userUnreadInfo = [];
            if (localStorage.getItem("unreadInfo")) {
                userUnreadInfo = JSON.parse(localStorage.getItem("unreadInfo"));
                userUnreadInfo = this.arrayDeduplication(userUnreadInfo);
            }
            let userInfo = JSON.parse(sessionStorage.getItem('userInfo')) || {};
            let accountId = '';
            if (userInfo && userInfo.accountId) {
                accountId = userInfo.accountId;
            }
            //  消息撤回推送
            if (message_.msgType == 18) {
                if (message_.body) {
                    if (this.$route.path != "/customer" && !this.$store.state.pcCsrShow) {
                        if (userUnreadInfo.length> 0 && accountId) {
                            for (let index = 0; index < userUnreadInfo.length; index++) {
                                if (userUnreadInfo[index].accountId) {
                                    if (userUnreadInfo[index].accountId == accountId) {
                                        if (userUnreadInfo[index].unreadMessageNum > 0) {
                                            userUnreadInfo[index].unreadMessageNum--;
                                            this.$store.state.unreadMessageNum = userUnreadInfo[index].unreadMessageNum;
                                        }
                                    }
                                } else {
                                    // 剔除坏数据
                                    userUnreadInfo.splice(index, 1);
                                    index--;
                                }
                            }
                        }
                        localStorage.setItem("unreadInfo", JSON.stringify(userUnreadInfo));
                    }
                }
            }
            // 客服消息
            if (message_.msgType == 15) {
                if (message_.body) {
                    if (this.$route.path != "/customer" && !this.$store.state.pcCsrShow) {
                        let csrMessage = Object.assign(JSON.parse(message_.body));
                        var sendMsg = {
                            req: {
                                recordId: csrMessage.customerServiceConsultId // 主键
                            },
                            action: "appDelivery"
                        };
                        sendMsg = JSON.stringify(sendMsg);
                        console.log("确认收到消息" + sendMsg); // 客服端显示 已送达（客服消息）
                        this.$store.state.APPPAGE.websocketsend(sendMsg);
                        this.$store.state.notification = csrMessage;
                        if (accountId) {
                            if (userUnreadInfo.length > 0) {
                                var result = userUnreadInfo.some(item => {
                                    // some   一真为真
                                    if (item.accountId == accountId) {
                                        return true;
                                    }
                                });
                            }
                            if (userUnreadInfo.length > 0 && result) {
                                for (let index = 0; index < userUnreadInfo.length; index++) {
                                    if (userUnreadInfo[index].accountId) {
                                        if (userUnreadInfo[index].accountId == accountId) {
                                            if (userUnreadInfo[index].unreadMessageNum) {
                                                userUnreadInfo[index].unreadMessageNum++;
                                                this.$store.state.unreadMessageNum = userUnreadInfo[index].unreadMessageNum;
                                            } else {
                                                userUnreadInfo[index].unreadMessageNum = 1;
                                                this.$store.state.unreadMessageNum = userUnreadInfo[index].unreadMessageNum;
                                            }
                                        }
                                    } else {
                                        // 剔除坏数据
                                        userUnreadInfo.splice(index, 1);
                                        index--;
                                    }
                                }
                            } else {
                                let unreadInfoItem = {
                                    accountId: accountId,
                                    unreadMessageNum: 1
                                };
                                this.$store.state.unreadMessageNum = 1;
                                userUnreadInfo.push(unreadInfoItem);
                            }
                        }
                        localStorage.setItem("unreadInfo", JSON.stringify(userUnreadInfo));
                    }
                }
            }
        },
        /**
         * @description:  数组去重
         * @param {type} 
         * @return: 
         */
        arrayDeduplication(arr_) {
            var subArr = [];
            for (let j = 0; j < arr_.length; j++) {
                for (let i = 0; i < arr_.length; i++) {
                    if (i != j && (arr_[j].accountId == arr_[i].accountId)) {
                        if (JSON.stringify(subArr).indexOf(j) == -1) {
                            subArr.push(j);
                        }
                    }
                }
            }
            for (let k = 0; k < subArr.length; k++) {
                arr_.splice(subArr[k], 1)
            }
            return arr_;
        }
    },
    mounted() { }
}

export default messageParsingJS = messageParsingJS



// WEBPACK FOOTER //
// ./src/components/customerService/messageParsing.js